export function importFailureMessage(value) {
    const response = value && value.response ? value.response : value;
    const body = response && response.data;
    const code = body && body.errorSchema && body.errorSchema.errorCode;
    if (importReloadRequired(value)) {
        return 'Muat ulang halaman sebelum melanjutkan. Belum ada perubahan data.';
    }
    if (code === 'EP-409' || (response && response.status === 409)) {
        return 'Berkas ini sudah diterima untuk diproses. Tidak ditambahkan ulang. Periksa hasil impor atau daftar siswa.';
    }
    if (code === 'EP-403' || (response && [401, 403].includes(response.status))) {
        return 'Tidak berhak mengimpor akun pada pilihan sekolah ini.';
    }
    const rowDetail = rejectedRowsDetail(response, code);
    if (rowDetail) {
        return rowDetail;
    }
    if (code === 'EP-006' || (response && response.status === 400)) {
        return 'Periksa format berkas Excel dan pilihan kelas sebelum mengimpor.';
    }
    return 'Hasil impor belum dapat dipastikan. Periksa daftar siswa sebelum mengunggah ulang berkas.';
}

// R7i: bila tidak ada akun yang terbuat dan ada baris dengan kolom L/P kosong atau tidak dikenal, admin-be menjawab
// HTTP 400 EP-006 dengan data.keterangan yang menyebut nomor baris Excel dan alasannya. Hanya jawaban ini yang
// menampilkan teks server; kode dan status lain tetap memakai teks tetap di atas. Teks dipangkas dan paling banyak
// 1000 karakter. Bila lebih panjang, bagian tengah (daftar baris) diganti " ... " agar awal dan alasan di akhir tetap
// terbaca. ImportSiswa.js menampilkannya sebagai teks biasa, bukan HTML.
const MAX_DETAIL_LENGTH = 1000;
const CUT_MARK = ' ... ';
function rejectedRowsDetail(response, code) {
    const data = response && response.status === 400 && code === 'EP-006' && response.data.data;
    const text = data && typeof data.keterangan === 'string' ? data.keterangan.trim() : '';
    const chars = Array.from(text);
    if (chars.length <= MAX_DETAIL_LENGTH) {
        return text;
    }
    const tail = Math.floor((MAX_DETAIL_LENGTH - CUT_MARK.length) / 2);
    const head = MAX_DETAIL_LENGTH - CUT_MARK.length - tail;
    return chars.slice(0, head).join('').trim() + CUT_MARK + chars.slice(chars.length - tail).join('').trim();
}

export function importReloadRequired(value) {
    const response = value && value.response ? value.response : value;
    return !!(response && response.status === 428 && response.data && response.data.errorSchema
        && response.data.errorSchema.errorCode === 'EP-428');
}

export async function runStudentImport(upload, setState) {
    setState({ isFetching: true, alertShow: false, openModalDownload: false, dataSiswa: [] });
    const failed = {
        alertShow: true,
        openModalDownload: false,
        dataSiswa: [],
        keterangan: 'Impor belum berhasil. Periksa format berkas dan pilihan kelas, lalu coba lagi.'
    };
    try {
        const response = await upload();
        const body = response && response.data;
        const data = body && body.data;
        if (!body || !body.errorSchema || body.errorSchema.errorCode !== 'EP-000' ||
            !data || !Array.isArray(data.dataSiswa) || !data.dataSiswa.length) {
            setState({ ...failed, reloadRequired: importReloadRequired(response), keterangan: importFailureMessage(response) });
            return;
        }
        setState({
            alertShow: true,
            openModalDownload: true,
            resMessage: body.errorSchema,
            dataSiswa: data.dataSiswa,
            keterangan: data.keterangan || 'Impor selesai. Unduh akun baru sebelum menutup hasil.',
            dataSekolah: data.dataSekolah || {},
            dataKelasParalel: data.dataKelasParalel || {}
        });
    } catch (error) {
        setState({ ...failed, reloadRequired: importReloadRequired(error), keterangan: importFailureMessage(error) });
    } finally {
        setState({ isFetching: false });
    }
}
